import React                   from 'react'
import Loading from '../common/Loading'
import { connect }             from 'react-redux'
import i18n from '../../i18n';

import {mapDispatchToProps} from "../mapDispatchToProps"

class Transaction extends React.Component {
  componentWillMount() {
    Promise.all([this.props.reportActions.reportTransactions()]).then(() => this.props.screenActions.screenLoading(false))
  }

  monthList() {
    if (!this.props.reportTransactions)
      return []

    const compare = (a, b) => {
      if (a < b) return 1;
      if (b < a) return -1;

      return 0;
    }

    return Object.keys(this.props.reportTransactions).sort(compare)
  }

  render() {
    const months = this.monthList()
    if(this.props.isLoading || !months.length)
      return <Loading />

    const {reportTransactions} = this.props
    const dataOfCurrentMonth = reportTransactions[months[0]]

    return (
      <div className="transaction-container small-container">
        <div className="row no-gutters">
          <div className="col-sm-12 title padl-0">{i18n.t("transaction.current_title")}</div>
          <div className="col-sm-12 content-body">
            <div className="row cur-block">
              <div className="col-sm-4 border-right-less text-center">
                <div className="cur-mon-title">{months[0]}</div>
                <div className="cur-mon-desc">（未確定）</div>
              </div>
              <div className="col-sm-4 border-right-less">
                <div className="trans-header">{i18n.t('transaction.withdraw_title')}</div>
                <div className="trans-content">{dataOfCurrentMonth.numberOfPayment}</div>
              </div>
              <div className="col-sm-4">
                <div className="trans-header">{i18n.t('transaction.payment_title')}</div>
                <div className="trans-content">{dataOfCurrentMonth.numberOfWithdraw}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="row no-gutters">
          <div className="col-sm-12 title">
            <div className="float-left">{i18n.t("transaction.past_title")}</div>
            <div className="float-right">
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 content-body">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col" className="w-25"> </th>
                  <th style={{textAlign: "left"}} scope="col" className="w-25"> {i18n.t('transaction.withdraw_title')}</th>
                  <th style={{textAlign: "left"}} scope="col" className="w-25"> {i18n.t('transaction.payment_title')}</th>
                </tr>
              </thead>
              <tbody>
                {months.slice(1).map(month => <tr key={month}>
                    <td>{month}</td>
                    <td>{reportTransactions[month].numberOfPayment}</td>
                    <td>{reportTransactions[month].numberOfWithdraw}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    isLoading: state.screen.get('isLoading'),
    reportTransactions: state.user.get('report').transactions
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Transaction)
